import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SurveyDialogComponent } from '../survey/survey.component';
import { LovedOnePassportModel, SurveyModel, SurveyReportModel, SurveyReportResponseModel, SurveyResponse } from '@nx-c4g/c4g-models';

@Injectable()
export class SurveyService {
  constructor(
    private dialog: MatDialog,
    private deviceService: DeviceDetectorService
  ) {}

  isMobile(): boolean {
    return this.deviceService.isMobile();
  }

  openSurveyDialog(survey: SurveyModel, existingResponses?: SurveyResponse[]) {
    const isMobile = this.isMobile();
    const isEditMode = !!existingResponses;
    const desktopHeight = isEditMode ? '748px' : '700px'; // Add 48px in edit mode for close button

    return this.dialog.open(SurveyDialogComponent, {
      data: {
        survey: survey,
        surveyResponses: existingResponses
      },
      width: isMobile ? '100vw' : '700px',
      height: isMobile ? '100vh' : desktopHeight,
      maxWidth: isMobile ? '100vw' : '700px',
      panelClass: isMobile ? 'full-screen-dialog' : '',
      disableClose: true
    });
  }

  updateLovedOneFromSurveyResponses(lovedOne: LovedOnePassportModel, responses: SurveyResponse[], patientSurvey: SurveyModel) {
    lovedOne.surveyResponses = responses;
    lovedOne.surveyReport = this.generateSurveyReport(responses, patientSurvey);

    // Parse name from survey responses
    const nameResponse = responses.find(r => r.stepId === 'name')?.response.find(r => r._id === 'nameText');
    if (nameResponse && nameResponse.values.length > 0) {
      const fullName = nameResponse.values[0];
      const nameParts = fullName.split(' ');
      lovedOne.LovedOnePersonalInfo.Name.First = nameParts[0] || '';
      lovedOne.LovedOnePersonalInfo.Name.Last = nameParts.slice(1).join(' ') || '';
    }

    // Parse birth year from survey responses
    const birthYearResponse = responses.find(r => r.stepId === 'birth_year')?.response.find(r => r._id === 'birthYearText');
    if (birthYearResponse && birthYearResponse.values.length > 0) {
      lovedOne.LovedOnePersonalInfo.DateOfBirth = '01/01/' + birthYearResponse.values[0];
    }

    // Parse address from survey responses
    const addressResponse = responses.find(r => r.stepId === 'address')?.response.find(r => r._id === 'address');
    if (addressResponse?.values?.[0]) {
      try {
        const addressData = JSON.parse(addressResponse.values[0]);
        lovedOne.LovedOnePersonalInfo.Address = {
          Clean: addressData.Clean,
          Street: addressData.Street,
          City: addressData.City,
          State: addressData.State,
          stateOrProvinceCode: addressData.stateOrProvinceCode,
          Country: addressData.Country,
          countryCode: addressData.countryCode,
          PostalCode: addressData.PostalCode,
          Latitude: addressData.Latitude,
          Longitude: addressData.Longitude,
          CityStatePostalCode: addressData.CityStatePostalCode,
          Type: addressData.Type,
          timeZone: addressData.timeZone
        };
      } catch (error) {
        console.error('Failed to parse address data:', error);
      }
    }

    return lovedOne;
  }

  generateSurveyReport(responses: SurveyResponse[], patientSurvey: SurveyModel): SurveyReportModel[] {
    const report: SurveyReportModel[] = [];
    for (const step of patientSurvey.steps) {
      const stepReport: SurveyReportModel = {
        stepId: step._id,
        stepType: step.stepType,
        reportTitle: step.reportTitle,
        reportDescription: step.reportDescription,
        responses: []
      };
      // Find the response for this step
      const stepResponses = responses.filter(r => r.stepId === step._id);
      for (const stepResponse of stepResponses) {
        for (const response of stepResponse.response) {
          const option = step.options.find(o => o._id === response._id);
          if (option) {
            const responseReport: SurveyReportResponseModel = {
              _id: response._id,
              reportText: option.reportText,
              reportDescription: option.reportDescription,
              values: response.values,
              showValueInReport: stepResponse.showValueInReport
            }
            stepReport.responses.push(responseReport);

          } else {
            console.error(`Option not found for response: ${response._id}`);
          }
        }
      }
      report.push(stepReport);
    }

    return report;
  }

}


